import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RightSidebar from '../../components/RightSidebar';

import {
  logout
} from '@xanadu/ui-shared/modules/userSession/actions';

import {
  displayOverlay
} from '../../modules/overlay/actions';

import {
  displayModal
} from '@xanadu/ui-shared/modules/modal/actions';

import {
  triggerUpdateRightSidebar
} from '../../modules/rightSidebar/actions';

const mapDispatchToProps = {
  displayModal,
  logout,
  displayOverlay,
  updateRightSidebar: triggerUpdateRightSidebar,
};

function mapStateToProps(state) {
  const widthSize = state.getIn(['application', 'widthSize']);
  const heightSize = state.getIn(['application', 'heightSize']);

  return {
    lastLogin: state.getIn(['user', 'lastLogin']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    unsubmittedOffers: state.get('unsubmittedOffers'),
    username: state.getIn(['user', 'username'], ''),
    currencies: state.getIn(['lookups', 'currencies']),
    oddsTypes: state.getIn(['lookups', 'oddsTypes']),
    sidebarContent: state.getIn(['rightSidebar', 'content']),
    sidebarVisible: state.getIn(['rightSidebar', 'visible']),
    widthSize: state.getIn(['application', 'widthSize']),
    topPosition: state.getIn(['application', 'topPosition']),
    bannerMessageVisible: state.getIn(['application', 'bannerMessageVisible']),
    uiVersion: state.getIn(['application', 'uiVersion']),
    cinemaMode: state.getIn(['application', 'cinemaMode']),
    isDesktop: widthSize > 480 && heightSize > 480,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RightSidebar));
